import * as EventListener from "../../common/helpers/event-listener";
import csrfToken from "../../common/helpers/csrf-token";
import { getFilterData, makeFilterUrl } from "../../common/helpers/helper";

const applyPagination = () => {
    EventListener.click("product-pagination-button", (button) => {
        const page = button.getAttribute("data-page");

        apply(page);
    });
};

const applySorting = () => {
    EventListener.click("product-sorting-button", (button) => {
        const buttons = document.querySelectorAll(".product-sorting-button");

        buttons.forEach((filterElement) => {
            filterElement.classList.remove("active");
        });

        button.classList.add("active");

        apply();
    });
};

const applyFilter = () => {
    EventListener.submit("productFilterForm", null, null, () => {
        apply(1, true);
    });
};

const applyDeleteFilterItem = () => {
    EventListener.click("delete-product-filter-item-button", (button) => {
        const elementId = button.getAttribute("data-property-id");
        const element = document.getElementById(elementId);

        if (element) {
            element.click();
        }

        apply();
    });
};

const applyResetFilter = () => {
    EventListener.click("reset-product-filter-button", () => {
        const form = document.getElementById("productFilterForm");
        const checkboxes = form.querySelectorAll('input[type="checkbox"]');

        if (checkboxes) {
            checkboxes.forEach((checkbox) => {
                checkbox.removeAttribute("checked");
            });
        }

        form.reset();

        apply(1, true);
    });
};

const apply = (page = 1, closeFilterBar = false) => {
    const form = document.getElementById("productFilterForm");
    const formData = new FormData(form);

    let requestData = getFilterData(formData);

    const sortingButton = document.querySelector(
        ".product-sorting-button.active",
    );
    const sorting = sortingButton.getAttribute("data-sorting");

    if (sorting !== "new-desc") {
        requestData = { ...requestData, sorting };
    }

    if (parseInt(page) !== 1) {
        requestData = { ...requestData, page };
    }

    const filterElements = document.querySelectorAll(".filter-part");

    filterElements.forEach((filterElement) => {
        filterElement.disabled = true;
    });

    makeFilterUrl(requestData);

    oc.ajax("Settings::onAjax", {
        data: { _token: csrfToken },
        update: {
            "catalog/products": ".products-wrapper",
            "catalog/filter/selected-filters": ".selected-filters-wrapper",
            "catalog/filter/reset-product-filter-button":
                ".reset-product-filter-button-wrapper",
            "gtm/catalog": ".gtm-catalog-wrapper",
        },
        loading: "#loader-line",
        complete: () => {
            filterElements.forEach((filterElement) => {
                filterElement.disabled = false;
            });

            window.scrollTo(0, 0);

            if (closeFilterBar) {
                window.filter.close();
            }

            const sortingDropdown = document.querySelector(
                ".sort-dropdown-list",
            );
            sortingDropdown.classList.add("hidden");
        },
    });
};

const closeFilterOnBackDropClick = () => {
    const dialogElement = document.getElementById("filter");

    if (dialogElement) {
        dialogElement.addEventListener("click", (event) => {
            if (event.target === dialogElement) {
                dialogElement.close();
            }
        });
    }
};

applySorting();
applyFilter();
applyDeleteFilterItem();
applyResetFilter();
applyPagination();
closeFilterOnBackDropClick();
